import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";

import CustomSnapPolygonMode from "./snap/CustomSnapPolygonMode";
import { removeGuides } from "./helper";

const drawPolygon: DrawCustomMode = {
  ...CustomSnapPolygonMode,

  onSetup: function onSetup(opts) {
    // We store the mode options so that we can access them later to reinitialize the mode if needed (e.g. after undo/redo)
    this._ctx.options.modeOptions = opts || {};

    const state = CustomSnapPolygonMode.onSetup?.call(this, opts);
    removeGuides.call(this);

    return state;
  },

  onStop(state) {
    CustomSnapPolygonMode.onStop?.call(this, state);
    this._ctx.options.modeOptions = {};
  },
};

export default drawPolygon;
